export const TITLE_MAX = 200;

export const validateBriefTitle = (title) => {
    const trimmed = title.trim();
    if (!trimmed) return "Brief title is required";
    if (trimmed.length > TITLE_MAX) return `Title must be under ${TITLE_MAX} characters`;
    return null; // valid
};

export const validateBudget = (budget) => {
    if (budget === "" || budget === null || budget === undefined) return null; // optional
    if (Number.isNaN(Number(budget)) || Number(budget) < 0) return "Budget must be a positive number";
    return null;
};

export const validateAssignee = (assignee) => {
    if (!assignee || assignee.length === 0) return "Assignee is required";
    return null;
};

export const validateReviewer = (reviewer) => {
    if (!reviewer || reviewer.length === 0) return "Reviewer is required";
    return null;
};

// Compares by calendar day, not exact instant — a deadline of "today" is still
// valid however far into the day it currently is.
//
// originalDeadline (already in the same 'YYYY-MM-DD' input-value shape, e.g.
// via toDateInputValue) mirrors the backend's own PATCH rule (routes/briefs.js):
// a past deadline is only rejected when it's actually changing. Without this,
// editing a brief that's already overdue — every Delayed brief, by definition —
// would load with its own stored deadline pre-filled, fail this check
// immediately, and permanently disable Save until the deadline itself was
// bumped forward, even for an edit that has nothing to do with the deadline.
export const validateDeadline = (deadline, originalDeadline = null) => {
    if (!deadline) return "Deadline is required";
    if (originalDeadline && deadline === originalDeadline) return null;
    const selected = new Date(deadline);
    if (Number.isNaN(selected.getTime())) return "Deadline is invalid";
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    selected.setHours(0, 0, 0, 0);
    if (selected < today) return "Deadline can't be in the past";
    return null;
};

export const validateDescription = (description) => {
    if (!description || !description.trim()) return "Description is required";
    return null;
};

export const hasErrors = (errors) => Object.values(errors).some(Boolean);
